import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMicroscope, faHeadphones, faWaveSquare, faSpinner } from '@fortawesome/free-solid-svg-icons';
import './EsamiPage.css';

const EsamiPage: React.FC = () => {
  return (
    <div className="esami-page">
      {/* Header Section */}
      <section className="esami-header">
        <div className="esami-header-container">
          <p className="esami-header-label">ESAMI DIAGNOSTICI</p>
          <h1 className="esami-header-title">Esami Specialistici</h1>
          <p className="esami-header-description">
            Il Centro di Otorinolaringoiatria Mattina è dotato di strumentazione all'avanguardia per l'esecuzione 
            di esami diagnostici specialistici in campo otorinolaringoiatrico. Gli esami 
            vengono eseguiti direttamente in studio, garantendo massima precisione e comfort 
            per il paziente.
          </p>
        </div>
      </section>

      {/* Esami Cards Section */}
      <section className="esami-cards">
        <div className="esami-cards-container">
          <Link to="/esami/rinofaringolaringoscopia" className="esame-card">
            <div className="esame-card-icon">
              <FontAwesomeIcon icon={faMicroscope} />
            </div>
            <h3 className="esame-card-title">Rinofaringolaringoscopia a Fibre Ottiche</h3>
            <p className="esame-card-description">
              Esame endoscopico che consente la visualizzazione dettagliata delle vie 
              aeree superiori utilizzando una fibra ottica flessibile.
            </p>
            <span className="esame-card-link">Scopri di più →</span>
          </Link>

          <Link to="/esami/audiometrico" className="esame-card">
            <div className="esame-card-icon">
              <FontAwesomeIcon icon={faHeadphones} />
            </div>
            <h3 className="esame-card-title">Esame Audiometrico</h3>
            <p className="esame-card-description">
              Test dell'udito non invasivo per valutare la capacità uditiva e individuare 
              l'intensità acustica minima percepibile.
            </p>
            <span className="esame-card-link">Scopri di più →</span>
          </Link>

          <Link to="/esami/impedenzometria" className="esame-card">
            <div className="esame-card-icon">
              <FontAwesomeIcon icon={faWaveSquare} />
            </div>
            <h3 className="esame-card-title">Impedenzometria</h3>
            <p className="esame-card-description">
              Valuta il funzionamento della catena di trasmissione del suono, l'elasticità 
              del timpano e la funzionalità della tuba di Eustachio.
            </p>
            <span className="esame-card-link">Scopri di più →</span>
          </Link>

          <Link to="/esami/vestibolare" className="esame-card">
            <div className="esame-card-icon">
              <FontAwesomeIcon icon={faSpinner} />
            </div>
            <h3 className="esame-card-title">Esame Vestibolare</h3>
            <p className="esame-card-description">
              Test non invasivo per diagnosticare le cause di vertigini, instabilità 
              e disturbi dell'equilibrio.
            </p>
            <span className="esame-card-link">Scopri di più →</span>
          </Link>
        </div>
      </section>

      {/* CTA Section */}
      <section className="esami-cta">
        <div className="esami-cta-container">
          <h2 className="esami-cta-title">Hai bisogno di prenotare un esame?</h2>
          <p className="esami-cta-description">
            Contattaci per maggiori informazioni o per fissare un appuntamento
          </p>
          <Link to="/#prenota" className="esami-cta-btn">
            Prenota ora
          </Link>
        </div>
      </section>
    </div>
  );
};

export default EsamiPage;
